import dayjs from 'dayjs';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';

dayjs.extend(isSameOrBefore);

export default class Presenter {
  constructor(model, minAge, onSuccess, onError) {
    this.model = model;
    this.minAge = minAge;
    this.onSuccess = onSuccess;
    this.onError = onError;
  }

  onBirthdayChange(date) {
    this.model.errorText = '';
    this.model.selectedDate = date;
  }

  onBirthdaySelected() {
    // this.model.selectedDate = dateOfBirth;
  }

  onNextClick() {
    const { selectedDate } = this.model;

    if (selectedDate) {
      const minDateOfBirth = dayjs().subtract(this.minAge, 'year');
      if (selectedDate.isSameOrBefore(minDateOfBirth)) {
        this.onSuccess?.(new Date(selectedDate));
      } else {
        this.onError?.();
      }
    } else {
      this.model.errorText = 'age.landing.error_invalid_date';
    }
  }
}
